import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUiStore = defineStore('ui', () => {
    const noScroll = ref(false);
    const hasTransition = ref<'page' | 'menu' | 'none'>('none');

    function toggleScroll(value?: boolean) {
        noScroll.value = value ?? !noScroll.value;
        if (value === false) {
            document.documentElement.classList.add('no-scroll');
        } else {
            document.documentElement.classList.remove('no-scroll');
        }
    }

    return {
        noScroll,
        hasTransition,
        toggleScroll,
    };
});

export const hasScroll = () => window.innerWidth > document.body.clientWidth;
